<template>
  <header class="w-full bg-white">
    <div
      class="max-w-7xl mx-auto h-24 flex flex-row items-center justify-between gap-2 lg:gap-4 pb-0 px-2 sm:px-4"
    >
      <NuxtLink to="/" aria-label="Ana Sayfa">
        <img
          src="/img/logo/360-sosyal-logo.svg"
          alt="360 Sosyal"
          class="object-fit w-28 lg:w-40"
        />
      </NuxtLink>
      <nav
        class="hidden md:flex flex-row items-center text-nowrap sm-1 md:gap-2 lg:gap-4"
        aria-label="Ana Menü"
      >
        <h2
          class="text-[0.875rem] text-[#787da7] cursor-pointer"
          @click="scrollToElement('how-to-use')"
        >
          Nasıl Kullanılır
        </h2>
        <h2
          class="text-[0.875rem] text-[#787da7] cursor-pointer"
          @click="scrollToElement('what-can-you-do')"
        >
          Neler Yapabilirim?
        </h2>
        <h2
          class="text-[0.875rem] text-[#787da7] cursor-pointer"
          @click="scrollToElement('faqs')"
        >
          SSS
        </h2>
        <h2
          class="text-[0.875rem] text-[#787da7] cursor-pointer"
          @click="scrollToElement('technical-specifications')"
        >
          Özellikler
        </h2>
        <h2
          class="text-[0.875rem] text-[#787da7] cursor-pointer"
          @click="scrollToElement('contact-us')"
        >
          İletişim
        </h2>
      </nav>
      <div class="flex flex-row items-center gap-2">
        <template v-if="isLogin">
          <NuxtLink to="/home" aria-label="Panele Giriş">
            <button
              class="flex flex-row gap-2 items-center text-white bg-orange-500 text-nowrap rounded-md text-sm md:text-md px-2 py-2"
            >
              <Icon name="humbleicons:dashboard" class="size-5" />
              Panele Giriş
            </button>
          </NuxtLink>
          <NuxtLink @click="handleLogout" to="/" aria-label="Güvenli Çıkış">
            <button
              class="flex flex-row gap-2 items-center border border-orange-500 rounded-md bg-white text-orange-500 text-nowrap text-sm md:text-md px-2 py-2"
            >
              <Icon name="material-symbols:logout-rounded" class="size-5" />
              Güvenli Çıkış
            </button>
          </NuxtLink>
        </template>
        <template v-else>
          <NuxtLink to="/register" aria-label="Kayıt Ol">
            <button
              class="flex flex-row gap-2 items-center border border-orange-500 rounded-md bg-white text-orange-500 text-nowrap text-sm md:text-md px-2 py-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                role="presentation"
                class="fill-orange-500"
              >
                <g transform="translate(2 2)">
                  <path
                    d="M7.127,0C3.283,0,0,.581,0,2.909s3.262,2.93,7.127,2.93c3.844,0,7.127-.582,7.127-2.909S10.992,0,7.127,0Z"
                    transform="translate(0.75 13.206)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                  <path
                    d="M4.568,9.136A4.568,4.568,0,1,0,0,4.568,4.552,4.552,0,0,0,4.568,9.136Z"
                    transform="translate(3.309 0.75)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                  <path
                    d="M.5,0V4.01"
                    transform="translate(16.704 6.669)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                  <path
                    d="M4.09.5H0"
                    transform="translate(15.16 8.174)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                </g>
              </svg>
              Kayıt Ol
            </button>
          </NuxtLink>
          <NuxtLink to="/login" aria-label="Giriş Yap">
            <button
              class="flex flex-row gap-2 items-center text-white bg-orange-500 text-nowrap rounded-md text-sm md:text-md px-2 py-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                role="presentation"
              >
                <g transform="translate(3.5 2)">
                  <path
                    d="M9.121,6.7V4.551A4.561,4.561,0,0,0,0,4.531V6.7"
                    transform="translate(3.802 0.75)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                  <path
                    d="M11.433,11.873H3.792A3.792,3.792,0,0,1,0,8.081V3.792A3.792,3.792,0,0,1,3.792,0h7.641a3.792,3.792,0,0,1,3.792,3.792V8.081A3.792,3.792,0,0,1,11.433,11.873Z"
                    transform="translate(0.75 7.377)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                  <path
                    d="M.5,0V2.221"
                    transform="translate(7.863 12.203)"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="1.5px"
                  ></path>
                </g>
              </svg>
              Giriş Yap
            </button>
          </NuxtLink>
        </template>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'

const userStore = useUserStore()
const { isLogin } = storeToRefs(userStore)

function scrollToElement(elementId: string) {
  const element = document.getElementById(elementId)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

function handleLogout() {
  userStore.logout()
}

onMounted(() => {
  if (isLogin.value) {
    userStore.getMe()
  }
})
</script>
